var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexedbiceps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flexed biceps"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.289 17.3574L5.86565 17.3574C3.19377 17.3574 1.88281 15.1869 1.91057 13.4375C1.91057 11.5215 4.63518 4.50778 4.63518 4.50778C5.09221 3.36521 5.4874 2.42931 6.83245 2.45112C7.86956 2.45112 9.86467 3.29488 9.86467 4.98238C9.86467 5.89644 9.22307 6.1689 9.22307 6.1689C9.22307 6.71382 8.77483 7.23238 8.30022 7.23238H6.19963C6.19963 7.23238 7.96458 10.7749 8.11565 11.0556C8.26672 11.3363 8.41448 11.0556 8.41448 11.0556C9.01213 9.23628 11.016 7.80912 12.7914 7.80912C15.3162 7.8085 17.6251 10.0709 17.6254 12.1821C17.6254 12.1819 17.6254 12.1817 17.6254 12.1814V12.1826C17.6254 12.1824 17.6254 12.1822 17.6254 12.1821C17.6251 14.8617 15.8497 17.3574 12.289 17.3574Z",
    fill: "#7750E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6254 12.1826V12.1814C17.6254 12.1817 17.6254 12.1819 17.6254 12.1821C17.6254 12.1822 17.6254 12.1824 17.6254 12.1826Z",
    fill: "#7750E9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51562 4.12106L7.24512 5.04831H8.42285C8.15918 4.68797 7.23281 3.9945 6.51562 4.12106Z",
    fill: "#1F1E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23049 6.16535C9.22539 6.16777 9.22266 6.16893 9.22266 6.16893C9.22266 6.71385 8.77441 7.23241 8.2998 7.23241H6.28031C6.28031 7.23241 6.51515 7.7762 6.80869 8.45456C5.22861 8.32331 4.6875 6.68309 4.6875 6.68309H5.14565C5.15161 6.68589 5.15762 6.68882 5.16369 6.69188H8.15039C8.44922 6.69188 9.09961 6.42381 8.63379 5.56248C8.79662 5.56248 9.13893 5.80918 9.23049 6.16535Z",
    fill: "#1F1E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99142 11.0197C8.88634 10.8466 8.73443 10.7288 8.56564 10.6664C8.50814 10.7938 8.4574 10.9237 8.41406 11.0556C8.41406 11.0556 8.36115 11.1562 8.28627 11.1767C8.37363 11.1817 8.459 11.2266 8.51056 11.3116L10.1775 14.058C10.2581 14.1908 10.4311 14.2331 10.5639 14.1525C10.6967 14.0719 10.739 13.8989 10.6584 13.7661L8.99142 11.0197Z",
    fill: "#1F1E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55155 11.0153C7.64646 10.8611 7.77855 10.7513 7.9264 10.686C8.02266 10.8766 8.09053 11.0097 8.11524 11.0556C8.15775 11.1346 8.2 11.1692 8.23877 11.178C8.15738 11.187 8.07931 11.231 8.0306 11.3101L6.40359 13.954C6.32218 14.0863 6.14895 14.1275 6.01666 14.0461C5.88437 13.9647 5.84313 13.7915 5.92453 13.6592L7.55155 11.0153Z",
    fill: "#1F1E25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexedbiceps);
export default __webpack_public_path__ + "static/media/Flexed biceps.51f0fb602ec8fb0312da60aadf72fa1c.svg";
export { ForwardRef as ReactComponent };